import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { BrowserModule } from '@angular/platform-browser';
import { CoreModule } from './core/core.module';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { EnterpriseFormModule } from '@rawlings/enterprise-form';
import { EnterpriseModuleTestHostModule } from '@rawlings/enterprise-module-test-host';
import { environment } from 'src/environments/environment';
import { FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { MaterialModule, RawlingsMaterialCoreModule } from '@rawlings/material-core';
import { MemberResponsePortalModule } from './member-response-portal/member-response-portal.module';
import { NgModule } from '@angular/core';
import { RawlingsWijmoCoreModule } from '@rawlings/wijmo-core';
import { WjGridFilterModule } from '@grapecity/wijmo.angular2.grid.filter';
import { WjGridGrouppanelModule } from '@grapecity/wijmo.angular2.grid.grouppanel';
import { WjGridModule } from '@grapecity/wijmo.angular2.grid';
import { WjNavModule } from '@grapecity/wijmo.angular2.nav';

@NgModule({
    declarations: [
        AppComponent
    ],
    imports: [
        AppRoutingModule,
        BrowserAnimationsModule,
        BrowserModule,
        CoreModule,
        DragDropModule,
        EnterpriseFormModule,
        EnterpriseFormModule,
        EnterpriseModuleTestHostModule,
        FormsModule,
        HttpClientModule,
        MaterialModule,
        MemberResponsePortalModule.ForRoot(environment.apiUrl, false),
        RawlingsMaterialCoreModule,
        RawlingsWijmoCoreModule,
        WjGridFilterModule,
        WjGridGrouppanelModule,
        WjGridModule,
        WjNavModule
    ],
    providers: [],
    bootstrap: [
        AppComponent
    ]
})
export class AppModule { }
